import $http from '../helpers/$http';
import {API_HOST} from '../constants/constants';
import apiHelper from '../helpers/apiHelper';

const AmplusImmobAPI = {
     Immoblies: (body)=>{
        return $http.post(API_HOST + '/api/standard/euler/immobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
     },

     Mobilies: (body)=>{
        return $http.post(API_HOST + '/api/standard/euler/mobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
     },

     CmdCommandStatus: (body)=>{
        return $http.post(API_HOST + '/api/standard/euler/cmndstatus', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
     },

     ListCmnds: (body)=>{
        return $http.post(API_HOST + '/api/standard/euler/listcmnds', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
     }
     
}

export default AmplusImmobAPI;